import React, { useState, useEffect } from "react";
import {
  notification,
  Button,
  Modal,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Form,
  Radio,
} from "antd";
import NetworkService from "../../services/NetworkService";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useAtom } from "jotai";
import { Link, Location, useLocation, useNavigate } from "react-router-dom";
import CertificateModal from "../../components/CertificateModal";
import { accessTokenAtom } from "../../atoms";
import { useMsal, useAccount } from "@azure/msal-react";
import { graphrequest, loginRequest } from "../../authConfig";
const { TextArea } = Input;

function EditCertificateTemplate() {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [templates, setTemplates] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalDisplay, setModalDisplay] = useState(false);
  const location = useLocation();
  const [state] = useState(location.state);
  const [newValues, setNewValues] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      if (account) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .then((response) => {
            console.log("CH", response);

            setAccessToken(response.accessToken);
            return response.accessToken;
          })
          .then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj.getCertificateEmailTemplateService(token).then((res) => {
              setCurrentData(res.data);
              setTemplates(res.data);
              setLoading(false);
            });
          });
      }
    }

    setLoading(true);
    getData();
  }, []);

  const openNotification = () => {
    api.error({
      message: `Delete Error`,
      description: "Delete Error Content",
      placement: "top",
    });
  };

  const handleOk = (values) => {
    let inputBody;
    const networkServiceObj = new NetworkService();
    if (state.label === "Residential") {
      inputBody = {
        templateName: values.templateName,
        backGroundImage: state.record.backGroundImage,
        heading: values.heading,
        heading2: values.heading2,
        row1Text1: values.row1Text1,
        row2: values.row2,
        row3Text1: values.row3Text1,
        row3Text2: "",
        row4: values.row4,
        modifiedBy: accounts[0].name,
        createdBy: state.record.createdBy,
      };

      networkServiceObj
        .editResidentialCertificateTemplateService(inputBody, state.record.id, accessToken)
        .then((res) => {
          if (res.result.messageCode == 201) {
            navigate("/certificateTemplate");
          }
        })
        .catch(() => {
          openNotification();
        });
    } else if (state.label === "C&I") {
      inputBody = {
        templateName: values.templateName,
        backGroundImage: state.record.backGroundImage,
        heading: values.heading,
        row1Text1: values.row1Text1,
        row2: values.row2,
        row3: values.row3,
        row4Text1: values.row4Text1,
        row4Text2: values.row4Text2,
        modifiedBy: accounts[0].name,
        createdBy: state.record.createdBy,
      };

      networkServiceObj
        .editCnICertificateTemplateService(inputBody, state.record.id, accessToken)
        .then((res) => {
          if (res.result.messageCode == 201) {
            navigate("/certificateTemplate");
          }
        })
        .catch(() => {
          openNotification();
        });
    }
  };

  const previewCert = () => {
    form
      .validateFields()
      .then((values) => {
        setNewValues({ ...values, headerImage: state.headerImage, logoImage: state.logoImage });
      })
      .then(() => {
        setModalDisplay(true);
      });
  };

  return (
    <div
      className="App"
      style={{
        width: "80%",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        margin: "auto",
      }}
    >
      {contextHolder}
      <Form
        id="retirementForm"
        name="basic"
        form={form}
        labelCol={{ span: 6 }}
        labelAlign={"left"}
        wrapperCol={{
          span: 8,
        }}
        style={{ width: "100%" }}
        onFinish={handleOk}
        onFinishFailed={() => alert("hello")}
        autoComplete="off"
        fields={
          state.label === "Residential"
            ? [
                { name: "templateName", value: state.record.templateName },
                { name: "heading", value: state.record.heading },
                { name: "heading2", value: state.record.heading2 },
                { name: "row1Text1", value: state.record.row1Text1 },
                { name: "row2", value: state.record.row2 },
                { name: "row3Text1", value: state.record.row3Text1 },
                { name: "row3Text2", value: state.record.row3Text2 },
                { name: "row4", value: state.record.row4 },
              ]
            : [
                { name: "templateName", value: state.record.templateName },
                { name: "heading", value: state.record.heading },
                { name: "row1Text1", value: state.record.row1Text1 },
                { name: "row2", value: state.record.row2 },
                { name: "row3", value: state.record.row3 },
                { name: "row4Text1", value: state.record.row4Text1 },
                { name: "row4Text2", value: state.record.row4Text2 },
              ]
        }
      >
        <Form.Item
          label="Template Name"
          name="templateName"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Template Name is required.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Heading"
          name="heading"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Heading is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        {state.label === "Residential" ? (
          <Form.Item
            label="Heading 2"
            name="heading2"
            wrapperCol={{
              span: 16,
            }}
          >
            <TextArea rows={4} />
          </Form.Item>
        ) : null}

        <Form.Item
          label="Row 1 Text 1"
          name="row1Text1"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Row 1 Text 1 is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Row 2"
          name="row2"
          wrapperCol={{
            span: 16,
          }}
          rules={[
            {
              required: true,
              message: "Row 2 is required.",
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        {state.label === "Residential" ? (
          <Form.Item
            label="Row 3"
            name="row3Text1"
            wrapperCol={{
              span: 16,
            }}
            rules={[
              {
                required: true,
                message: "Row 3 is required.",
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          <Form.Item
            label="Row 3"
            name="row3"
            wrapperCol={{
              span: 16,
            }}
            rules={[
              {
                required: true,
                message: "Row 3 is required.",
              },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        {state.label === "Residential" ? (
          <Form.Item
            label="Row 4"
            name="row4"
            wrapperCol={{
              span: 16,
            }}
          >
            <Input />
          </Form.Item>
        ) : (
          <Form.Item
            label="Row 4 Text 1"
            name="row4Text1"
            wrapperCol={{
              span: 16,
            }}
            rules={[
              {
                required: true,
                message: "Row 4 Text 1 is required.",
              },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        {state.label === "C&I" ? (
          <Form.Item
            label="Row 4 Text 2"
            name="row4Text2"
            wrapperCol={{
              span: 16,
            }}
            rules={[
              {
                required: true,
                message: "Row 4 Text 2 is required.",
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginRight: 25 }}>
            Submit
          </Button>

          <Link to="/certificateTemplate">
            <Button htmlType="button" style={{ marginRight: 25 }}>
              Back
            </Button>
          </Link>

          {/* <Button type="link" htmlType="button" style={{marginRight:25}} onClick={()=>previewCert()}>
          Preview Certificate
        </Button> */}
        </Form.Item>
      </Form>
      {/* <CertificateModal data={newValues} display={modalDisplay} setDisplay={()=>{setModalDisplay()}}/> */}
    </div>
  );
}

export default EditCertificateTemplate;
